// @flow
export const PRINTING_WINDOW_OPTIONS = 'noopener,location=no,menubar=no,resizable=yes,height=1100,width=950,status=no,toolbar=no';

class PrintingService {

  printWindowWithData(url: string, dataKey: string, data: Object) {
    window.localStorage.setItem(dataKey, JSON.stringify(data));

    window.open(url, '_blank', PRINTING_WINDOW_OPTIONS);
  }

  getData(dataKey: string): Object | void {
    const data = window.localStorage.getItem(dataKey);
    if (!data) {
      return undefined;
    }

    window.localStorage.removeItem(dataKey);

    return JSON.parse(data);
  }
}

export default new PrintingService();



// WEBPACK FOOTER //
// ./src/common/services/PrintingService.js